import React from 'react';

import {
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Col,
  Media,
  Spinner,
} from 'reactstrap';

import utils from '../utils.js';

const EVENT_LOOKBACK_PERIOD = 1000 * 60 * 60 * 24 * 1;

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.panes = ['ATTEMPTS', 'SKIPPED'];
    this.neweggPanes = ['ATTEMPTS'];
    this.state = {
      activeNav: 1,
      chartExample1Data: 'data1',
      activeRetailer: 'amazon',
      activePane: 'ATTEMPTS',
      activeNeweggPane: 'ATTEMPTS',
      ...this.getResetDefaults(),
    };
  }
  toggleNavs = (e, index) => {
    e.preventDefault();
    this.setState({
      activeNav: index,
      chartExample1Data:
        this.state.chartExample1Data === 'data1' ? 'data2' : 'data1',
    });
  };

  getResetDefaults() {
    return {
      attemptEvents: null,
      attemptEventsLoading: false,
      attemptSkippedEvents: null,
      attemptSkippedEventsLoading: false,
    };
  }

  async componentDidMount() {
    await this.updateAllEvents();
  }

  async componentDidUpdate(prevProps) {
    if (this.props.didSelectedCredChange(this.props, prevProps)) {
      this.setState(this.getResetDefaults());
      await this.updateAllEvents();
    }
  }

  async updateAttemptEvents(vendor) {
    if (!this.props.selectedAccount) return;
    this.setState({
      attemptEvents: null,
      attemptEventsLoading: true,
    });

    const { events, errorMessage } = await utils.getEvents(
      vendor,
      this.props.selectedAccount.vendorAccountId,
      [utils.vendorToAttemptEvent[vendor]],
      EVENT_LOOKBACK_PERIOD
    );
    if (events) {
      this.setState({
        attemptEvents: events,
        attemptEventsLoading: false,
      });
    }
  }

  async updateAttemptSkippedEvents(vendor) {
    if (!this.props.selectedAccount) return;
    this.setState({
      attemptSkippedEvents: null,
      attemptSkippedEventsLoading: true,
    });
    const { events, errorMessage } = await utils.getEvents(
      vendor,
      this.props.selectedAccount.vendorAccountId,
      [utils.vendorToAttemptSkippedEvent[vendor]],
      EVENT_LOOKBACK_PERIOD
    );
    if (events) {
      this.setState({
        attemptSkippedEvents: events,
        attemptSkippedEventsLoading: false,
      });
    }
  }

  async updateAllEvents() {
    if (!this.props.selectedAccount) return;
    const vendor = this.props.selectedCred.vendor;
    await Promise.allSettled([
      this.updateAttemptEvents(vendor),
      this.updateAttemptSkippedEvents(vendor),
    ]);
  }

  getSpinner() {
    return <Spinner className="ml-2 mb-1" size="sm" color="warning" />;
  }

  renderCheckoutSpinner() {
    return <>{this.props.checkoutsLoading ? this.getSpinner() : null}</>;
  }

  renderEventsSpinner() {
    return (
      <>
        {this.state.attemptEventsLoading ||
        this.state.attemptSkippedEventsLoading
          ? this.getSpinner()
          : null}
      </>
    );
  }

  renderCheckoutRows() {
    let checkouts = this.props.checkouts;
    if (!checkouts) return;

    checkouts = checkouts.sort((a, b) => b.checkoutTime - a.checkoutTime);
    let count = 0;

    return checkouts.map((checkout) => {
      const {
        checkoutTime,
        productId,
        productName,
        productLink,
        orderNumber,
        orderStatus,
        orderStatusTime,
        orderEmail,
      } = checkout;

      const dateString = utils.getPrettyTime(checkoutTime);
      const orderStatusTimeString = utils.getPrettyTime(orderStatusTime);

      count += 1;
      return (
        <tr key={checkoutTime} className="">
          <td>{dateString}</td>
          <td scope="row">
            <Media className="align-items-center">
              <Media>
                <span className="mb-0 text-sm">
                  <a className="text-white" href={productLink} target="_blank">
                    {productName}
                  </a>
                </span>
              </Media>
            </Media>
          </td>
          <td>{productId}</td>
          <td>{orderEmail}</td>
          {/*<td>*/}
          {/*  { a.isCombo ? 'Combo' : 'Single' }*/}
          {/*</td>*/}
          {/*<td>*/}
          {/*  { event.prettyEventName }*/}
          {/*</td>*/}
        </tr>
      );
    });
  }

  renderCheckoutFailedRows() {
    let events = this.props.checkoutFailedEvents;
    if (!events) return;

    events = events.sort((a, b) => b.eventTime - a.eventTime);
    let count = 0;

    return events.map((event) => {
      const a = event.eventData.alert;
      const dateString = utils.getPrettyTime(event.eventTime);
      count += 1;
      return (
        <tr key={event.eventTime} className="">
          <td>{dateString}</td>
          {/*<td>{ utils.titleCase(a.vendor) }</td>*/}
          <td>{a.id}</td>
          <td scope="row">
            <Media className="align-items-center">
              <Media>
                <span className="mb-0 text-sm">
                  <a className="text-white" href={a.link} target="_blank">
                    {a.name}
                  </a>
                </span>
              </Media>
            </Media>
          </td>
          <td>{a.isCombo ? 'Combo' : 'Single'}</td>
          {/*<td>*/}
          {/*  { event.prettyEventName }*/}
          {/*</td>*/}
        </tr>
      );
    });
  }

  switchToAmazon() {
    this.setState({
      activeRetailer: 'amazon',
    });
  }

  switchToNewegg() {
    this.setState({
      activeRetailer: 'newegg',
    });
  }

  renderEventTable() {
    const vendor =
      this.props.selectedAccount && this.props.selectedAccount.vendor;
    return (
      <Card className="bg-default shadow">
        <CardHeader className="bg-default border-0 sticky z-999">
          <h3 className="mb-0 text-white">
            Events {this.renderEventsSpinner()}
          </h3>
          {this.renderPanesSwitch()}
          <div className="text-gray">
            Note: Attempts aren't shown until the drop is completed, which can
            take 10+ minutes. Retries aren't shown. Got questions? Read the{' '}
            <a href="https://docs.snailbot.io/faq" target="_blank">
              FAQ
            </a>
            .
          </div>
        </CardHeader>
        {this.renderVendorTable()}
        <CardFooter className="bg-default border-0 text-gray">
          Showing last 24 hours of activity
        </CardFooter>
      </Card>
    );
  }

  renderNeweggTable() {
    return (
      <Table
        className="align-items-center table-dark table-flush overflow-hidden"
        responsive
      >
        <thead className="thead-dark">
          <tr>
            <th scope="col">Time</th>
            {/*<th scope="col">Vendor</th>*/}
            <th scope="col">ID</th>
            <th scope="col">Product Link</th>
            <th scope="col">SKU</th>
            <th scope="col">Type</th>
            {/*<th scope="col">Result</th>*/}
          </tr>
        </thead>
        <tbody>{this.renderCheckoutFailedRows()}</tbody>
      </Table>
    );
  }

  renderPanesSwitch() {
    return (
      <div className="mb-2 mr-3">
        {this.panes.map((l) => (
          <Button
            key={l}
            color={this.state.activePane === l ? 'primary' : 'default'}
            size="sm"
            type="button"
            className="mr-2 mt-3"
            onClick={() => this.setState({ activePane: l })}
          >
            {l}
          </Button>
        ))}
      </div>
    );
  }

  renderNeweggPanesSwitch() {
    return (
      <div className="mb-2 mr-3">
        {this.neweggPanes.map((l) => (
          <Button
            key={l}
            color={this.state.activeNeweggPane === l ? 'primary' : 'default'}
            size="sm"
            type="button"
            className="mr-2 mt-3"
            onClick={() => this.setState({ activeNeweggPane: l })}
          >
            {l}
          </Button>
        ))}
      </div>
    );
  }

  renderAttemptRows() {
    let events = this.state.attemptEvents;
    if (!events) return;

    events = events.sort((a, b) => b.eventTime - a.eventTime);
    let count = 0;
    const vendor = this.props.selectedCred.vendor;

    return events.map((event) => {
      const {
        eventTime,
        productName,
        productId,
        vendorProductId,
        price,
        email,
        failReason,
      } = event;
      const dateString = utils.getPrettyTime(eventTime);
      return (
        <tr key={eventTime} className="">
          <td>{dateString}</td>
          <td>
            <Media className="align-items-center">
              <Media>
                <span className="mb-0 text-sm">
                  <a
                    className="text-white"
                    href={utils.getDpUrlForVendor(vendor, vendorProductId)}
                    target="_blank"
                  >
                    {productName}
                  </a>
                </span>
              </Media>
            </Media>
          </td>
          <td>{price ? `$${price}` : 'N/A'}</td>
          <td>{failReason ? `${failReason}` : 'OOS'}</td>
          <td>{`${vendorProductId} | ${productId}`}</td>
          <td>{email || 'N/A'}</td>
        </tr>
      );
    });
  }

  renderAttemptPane() {
    return (
      <>
        <thead className="thead-dark">
          <tr>
            <th scope="col">Time</th>
            <th scope="col">Product</th>
            <th scope="col">Price</th>
            <th scope="col">Status</th>
            <th scope="col">Item ID | Snail ID</th>
            <th scope="col">Account</th>
          </tr>
        </thead>
        <tbody>{this.renderAttemptRows()}</tbody>
      </>
    );
  }

  renderAttemptSkippedPane() {
    return (
      <>
        <thead className="thead-dark">
          <tr>
            <th scope="col">Time</th>
            <th scope="col">Product</th>
            <th scope="col">Price</th>
            <th scope="col">Skip Reason</th>
            <th scope="col">Item ID | Snail ID</th>
            <th scope="col">Account</th>
          </tr>
        </thead>
        <tbody>{this.renderAttemptSkippedRows()}</tbody>
      </>
    );
  }

  getSkipReasonForSkipEvent(event) {
    const { reason, maxPrice, price, limit, lastLimitResetTime } = event;
    if (reason === utils.AM_SKIP_REASONS.NO_INTENT) {
      return "You weren't tracking this product.";
    } else if (reason === utils.AM_SKIP_REASONS.EXCEEDS_MAX_PRICE) {
      return `Listing price of $${price} exceeds your max price of $${maxPrice}.`;
    } else if (reason === utils.AM_SKIP_REASONS.LIMIT_REACHED) {
      return `You've reached your checkout limit of ${limit} in your 30-day period. Last limit reset: ${
        (lastLimitResetTime && utils.getPrettyTime(lastLimitResetTime)) || 'N/A'
      }`;
    } else {
      return 'Unknown reason. Contact support if you see this.';
    }
  }

  renderAttemptSkippedRows() {
    let events = this.state.attemptSkippedEvents;
    if (!events) return;
    const vendor = this.props.selectedCred.vendor;

    events = events.sort((a, b) => b.eventTime - a.eventTime);
    let i = 0;
    return events.map((event) => {
      i++;
      const {
        eventTime,
        productName,
        productId,
        vendorProductId,
        price,
        email,
      } = event;
      const dateString = utils.getPrettyTime(eventTime);
      return (
        <tr key={`${i}${eventTime}`} className="">
          <td>{dateString}</td>
          <td>
            <Media className="align-items-center">
              <Media>
                <span className="mb-0 text-sm">
                  <a
                    className="text-white"
                    href={utils.getDpUrlForVendor(vendor, vendorProductId)}
                    target="_blank"
                  >
                    {productName}
                  </a>
                </span>
              </Media>
            </Media>
          </td>
          <td>{price ? `$${price}` : 'N/A'}</td>
          <td>{this.getSkipReasonForSkipEvent(event)}</td>
          <td>{`${vendorProductId} | ${productId}`}</td>
          <td>{email || 'N/A'}</td>
        </tr>
      );
    });
  }

  renderVendorTable() {
    return (
      <Table
        className="align-items-center table-dark table-flush overflow-hidden"
        responsive
      >
        {this.state.activePane === 'ATTEMPTS'
          ? this.renderAttemptPane()
          : this.renderAttemptSkippedPane()}
      </Table>
    );
  }

  render() {
    return (
      <>
        {/* Page content */}
        <Container className="mt--7" fluid>
          <Row>
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card className="bg-default shadow mb-4">
                <CardHeader className="bg-default border-0 sticky z-999">
                  <h3 className="text-white mb-0">
                    <span>
                      {this.props.checkouts && this.props.checkouts.length > 0
                        ? `${this.props.checkouts.length} `
                        : ''}
                      Checkouts
                    </span>
                    <span className="text-gray"> (all)</span>
                    {this.renderCheckoutSpinner()}
                  </h3>
                </CardHeader>
                <Table
                  className="align-items-center table-dark table-flush overflow-hidden"
                  responsive
                >
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">Time</th>
                      {/*<th scope="col">Vendor</th>*/}
                      <th scope="col">Product Link</th>
                      <th scope="col">SKU</th>
                      <th scope="col">Order Email</th>
                    </tr>
                  </thead>
                  <tbody>{this.renderCheckoutRows()}</tbody>
                </Table>
              </Card>

              {this.renderEventTable()}

              {/*<Card className="bg-default shadow">*/}
              {/*  <CardHeader className="bg-default border-0 sticky z-999">*/}
              {/*    <h3 className="text-white mb-0">*/}
              {/*      Checkout Attempts*/}
              {/*      {this.renderFailedCheckoutSpinner()}*/}
              {/*    </h3>*/}
              {/*    <div>*/}
              {/*      Note: Amazon attempts will not show up yet until we finish*/}
              {/*      revamping the system.*/}
              {/*    </div>*/}
              {/*  </CardHeader>*/}
              {/*  <Table*/}
              {/*    className="align-items-center table-dark table-flush overflow-hidden"*/}
              {/*    responsive*/}
              {/*  >*/}
              {/*    <thead className="thead-dark">*/}
              {/*      <tr>*/}
              {/*        <th scope="col">Time</th>*/}
              {/*        /!*<th scope="col">Vendor</th>*!/*/}
              {/*        <th scope="col">ID</th>*/}
              {/*        <th scope="col">Product Link</th>*/}
              {/*        <th scope="col">Type</th>*/}
              {/*        /!*<th scope="col">Result</th>*!/*/}
              {/*      </tr>*/}
              {/*    </thead>*/}
              {/*    <tbody>{this.renderCheckoutFailedRows()}</tbody>*/}
              {/*  </Table>*/}
              {/*</Card>*/}
            </Col>

            {/*  <Col className="mb-5 mb-xl-0" xl="4">*/}
            {/*    <Card className="bg-gradient-default shadow">*/}
            {/*      <CardHeader className="bg-transparent">*/}
            {/*        <Row className="align-items-center">*/}
            {/*          <div className="col">*/}
            {/*            <h6 className="text-uppercase text-light ls-1 mb-1">*/}
            {/*              Overview*/}
            {/*            </h6>*/}
            {/*            <h2 className="text-white mb-0">Attempts</h2>*/}
            {/*          </div>*/}
            {/*          <div className="col">*/}
            {/*            <Nav className="justify-content-end" pills>*/}
            {/*              <NavItem>*/}
            {/*                <NavLink*/}
            {/*                  className={classnames("py-2 px-3", {*/}
            {/*                    active: this.state.activeNav === 1*/}
            {/*                  })}*/}
            {/*                  href="#pablo"*/}
            {/*                  onClick={e => this.toggleNavs(e, 1)}*/}
            {/*                >*/}
            {/*                  <span className="d-none d-md-block">Month</span>*/}
            {/*                  <span className="d-md-none">M</span>*/}
            {/*                </NavLink>*/}
            {/*              </NavItem>*/}
            {/*              <NavItem>*/}
            {/*                <NavLink*/}
            {/*                  className={classnames("py-2 px-3", {*/}
            {/*                    active: this.state.activeNav === 2*/}
            {/*                  })}*/}
            {/*                  data-toggle="tab"*/}
            {/*                  href="#pablo"*/}
            {/*                  onClick={e => this.toggleNavs(e, 2)}*/}
            {/*                >*/}
            {/*                  <span className="d-none d-md-block">Week</span>*/}
            {/*                  <span className="d-md-none">W</span>*/}
            {/*                </NavLink>*/}
            {/*              </NavItem>*/}
            {/*            </Nav>*/}
            {/*          </div>*/}
            {/*        </Row>*/}
            {/*      </CardHeader>*/}
            {/*      <CardBody>*/}
            {/*        /!* Chart *!/*/}
            {/*        <div className="chart">*/}
            {/*          <Line*/}
            {/*            data={chartExample1[this.state.chartExample1Data]}*/}
            {/*            options={chartExample1.options}*/}
            {/*            getDatasetAtEvent={e => console.log(e)}*/}
            {/*          />*/}
            {/*        </div>*/}
            {/*      </CardBody>*/}
            {/*    </Card>*/}

            {/*  </Col>*/}
            {/*  /!*<Col xl="4">*!/*/}
            {/*  /!*  <Card className="bg-gradient-default shadow">*!/*/}
            {/*  /!*    <CardHeader className="bg-transparent">*!/*/}
            {/*  /!*      <Row className="align-items-center">*!/*/}
            {/*  /!*        <div className="col">*!/*/}
            {/*  /!*          <h6 className="text-uppercase text-muted ls-1 mb-1">*!/*/}
            {/*  /!*            Performance*!/*/}
            {/*  /!*          </h6>*!/*/}
            {/*  /!*          <h2 className="mb-0">Total orders</h2>*!/*/}
            {/*  /!*        </div>*!/*/}
            {/*  /!*      </Row>*!/*/}
            {/*  /!*    </CardHeader>*!/*/}
            {/*  /!*    <CardBody>*!/*/}
            {/*  /!*      /!* Chart *!/*!/*/}
            {/*  /!*      <div className="chart">*!/*/}
            {/*  /!*        <Bar*!/*/}
            {/*  /!*          data={chartExample2.data}*!/*/}
            {/*  /!*          options={chartExample2.options}*!/*/}
            {/*  /!*        />*!/*/}
            {/*  /!*      </div>*!/*/}
            {/*  /!*    </CardBody>*!/*/}
            {/*  /!*  </Card>*!/*/}
            {/*  /!*</Col>*!/*/}
            {/*</Row>*/}
            {/*<Row className="mt-5">*/}

            {/*  <Col xl="4">*/}

            {/*  </Col>*/}
          </Row>
        </Container>
      </>
    );
  }
}

export default Index;
